module.exports = __webpack_public_path__ + "assets/04f44023529c6043ee2e61351c619fcd.png";